@if (isSpecificGrid && isSpecificGridTitleDisplay) {
  <div [ngClass]="[!isDisplayed ? 'isHidden' : '', 'title']">
    <label>
      <strong>{{ gridTitle }}</strong>
    </label>
  </div>
}

<div
  #divContent
  [attr.data-cy-grid-tablename]="
    this.data ? (this.data['AD_FormDetail_ID'] ? this.data.columnName : this.data.tableName) : 'none'
  "
  [ngClass]="[!isDisplayed ? 'isHidden' : '', 'compContainer']"
  style.width="{{ cssWidth }}">
  @if (!noColumnToDisplay) {
    <div
      [ngClass]="[isGridCollapsed && isTabTopLevel ? 'gridCollapsed' : '', cssClass || '']"
      style.width="{{ cssWidth }}">
      @if (isMenuDisplay) {
        <iu-menu-bar-ui
          [activeTabID]="container?.activeTab?.id"
          [gridView]="this"
          [hasUniversalFilter]="hasUniversalFilter"
          [isDeleteable]="this.isDeleteable"
          [isFromForm]="fromForm"
          [isInsertRecord]="isInsertRecord"
          [isReadOnly]="isReadOnly"
          [isSplitView]="isSplitView"
          [isTabTopLevel]="isTabTopLevel"
          [tabId]="tabId"
          [visibleButton]="visibleButtons"
          [visibleTreeButton]="this.isTree"
          (changeViewEvent)="switchViewType($event)"
          (filterChange)="displayHideFilters($event)"
          (newEmitter)="openNew()"
          (openExportDataModalEmitter)="openExportDataModal($event)"
          (refreshEmitter)="refreshGrid()"
          (removeEmitter)="remove($event)" />
      }

      @if (isLoading) {
        <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
      }

      @switch (viewType) {
        @case ('tree') {
          <iu-tree-ui [data]="this.data" (selectItem)="forceOpenEditView($event)" />
        }

        @case ('kanban') {
          <iu-kanban-ui
            class="kanban-board"
            [DOMParentComponent]="this"
            [columnsDisplayAD]="this.data.columnsDisplayAD"
            [container]="container"
            [data]="data"
            [gridTabFilter]="gridTabFilter"
            [gridTabValidator]="gridTabValidator"
            [initGridParams]="initGridParams"
            [isCollapsed]="isGridCollapsed"
            [kanbanImageColumn]="this.data.kanbanImageColumn"
            [tabId]="tabId"
            [tableName]="this.data.tableName"
            (clickEmitter)="forceOpenEditView($event)" />
        }

        @case ('calendar') {
          <iu-calendar-view-ui
            [DOMParentComponent]="this"
            [container]="container"
            [data]="data"
            [gridTabFilter]="gridTabFilter"
            [gridTabValidator]="gridTabValidator"
            [initGridParams]="initGridParams"
            [isCollapsed]="isGridCollapsed"
            [tabId]="tabId"
            (clickEmitter)="forceOpenEditView($event)" />
        }

        @case ('chart') {
          <iu-chart-ui
            [DOMParentComponent]="this"
            [container]="container"
            [data]="data"
            [gridTabFilter]="gridTabFilter"
            [gridTabValidator]="gridTabValidator"
            [initGridParams]="initGridParams"
            [tabId]="tabId" />
        }

        @case ('cards') {
          <iu-cards-ui
            [DOMParentComponent]="this"
            [gridTabFilter]="gridTabFilter"
            [gridTabValidator]="gridTabValidator"
            [type]="data.tabType"
            (clickEmitter)="forceOpenEditView($event)" />
        }
      }
      <iu-grid-tab-infinity-scroll-headless-ui
        [DOMParentComponent]="this"
        [container]="container"
        [data]="data"
        [gridTabFilter]="gridTabFilter"
        [gridTabValidator]="gridTabValidator"
        [initFromSwitch]="initFromSwitch"
        [initGridParams]="initGridParams"
        [initAutosizeBehavior]="initAutosizeBehavior"
        [isTabTopLevel]="!gridPaginator"
        [isZoomTargetGrid]="isZoomTargetGrid"
        [ngStyle]="{ display: viewType === 'grid' ? 'block' : 'none' }"
        [query]="data?.query"
        [rowSelection]="rowSelection"
        [style.height.%]="gridPaginator ? 100 : 'unset'"
        [suppressRowClickSelection]="suppressRowClickSelection"
        [tabId]="tabId"
        [windowType]="windowType"
        (gridCellEditingStopped)="gridCellEditingStopped.emit($event)"
        (gridPrefLoaded)="gridPrefLoaded.emit($event)"
        (gridRefreshed)="gridRefreshed.emit($event)"
        (gridViewCellClicked)="gridCellClicked($event)"
        (multiSelectEmitter)="displayHideMultiButton($event)"
        (notifyGridTabAfterViewInitEmitter)="notifyGridTabAfterViewInitEmitter($event)" />
    </div>
  }

  @if (displayExportDataModal) {
    <div>
      <iu-modal-ui
        #exportDataModal
        [angularStyle]="{ 'iu-modal-body': { overflow: 'unset' } }"
        [appendTo]="'body'"
        [hasCloseBtn]="false"
        [title]="'exportData.title'"
        (closeModalEmitter)="displayExportDataModal = false">
        <iu-export-data-ui
          [datagridRequest]="currentRequest"
          [ids]="exportIds"
          [sourceModal]="exportDataModal"
          [tabId]="this.tabId"
          [tableId]="this.data.AD_Table_ID"
          [whereClause]="whereClause"
          (cancelExportDataEmitter)="displayExportDataModal = false" />
      </iu-modal-ui>
    </div>
  }

  @if (displayProcessUI) {
    <div>
      <iu-modal-ui
        [angularStyle]="{ 'iu-modal-body': { padding: 0 } }"
        [hasCloseBtn]="true"
        (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayProcessUI', value: false } })">
        <iu-process-ui
          [executeProcessWrapper]="executeProcessWrapper"
          [isModal]="true"
          [parentComponent]="this"
          [windowId]="processId"
          (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayProcessUI', value: false } })" />
      </iu-modal-ui>
    </div>
  }

  <div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
    <iu-modal-ui
      [isModalDisplay]="displayFormUI"
      [modalClass]="modalClass"
      [title]="specificWindowTitle"
      (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false } })">
      <ng-template #vcrSpecific />
    </iu-modal-ui>
  </div>
</div>

<!-- @if (displaySearch) {
  <iu-modal-ui
    data-cy="search-panel"
    [attr.data-cy-columnName]="this.searchLinkedComponent.autoComplete.data.columnName"
    [hidden]="!displaySearch"
    [title]="searchLinkedComponent.autoComplete.label"
    [hasCloseBtn]="true"
    (closeModalEmitter)="this.displaySearch = false">
    <div class="autocomplete-universal-filter">
      <iu-universal-filter-ui
        [tabId]="-1"
        [columns]="searchLinkedComponent.autoComplete.data.searchColumns"
        [gridTab]="gridTab" />
    </div>
    <iu-grid-tab-infinity-scroll-headless-ui
      #gridTab
      (searchEmitter)="
        searchLinkedComponent.setSearchSelectItem($event); displaySearch = false; searchPanelValidation = undefined
      "
      [data]="searchLinkedComponent.autoComplete.data"
      [container]="this"
      [isSearch]="true"
      [dataStored]="searchLinkedComponent.autoComplete.dataStored"
      [windowType]="windowType"
      rowSelection="single"
      [validation]="searchPanelValidation"
      [hasCheckBox]="searchLinkedComponent.autoComplete.data.columnName === 'M_Product_ID'" />
  </iu-modal-ui>
}
 -->
